/**
 * The element a surface scrolls in. `mj-agu-surface` IS the scrollport (the
 * immersive mixin gives it `height: 100%; overflow-y: auto`,
 * `_immersive-surface.scss`), and it outlives every module, so modules reach it
 * through their host adapter rather than `document.querySelector` — two live
 * surfaces (or two instances of one) must never read each other's offset.
 *
 * Held by composition on the adapter (dev-best-practices §4, containment over
 * inheritance) so it is testable without Router/Auth/DI.
 */
export class AGUScrollportHolder {
    private element: HTMLElement | null = null;

    Attach(element: HTMLElement): void {
        this.element = element;
    }

    /** No-op for an element that is not the attached one (a late destroy of a replaced instance). */
    Detach(element: HTMLElement): void {
        if (this.element === element) this.element = null;
    }

    /** 0 when nothing is attached (first render, jsdom). */
    get ScrollTop(): number {
        return this.element?.scrollTop ?? 0;
    }

    /** Plain assignment: smooth scrolling is a measured no-op on this container (`_immersive-surface.scss`). */
    set ScrollTop(value: number) {
        if (this.element) this.element.scrollTop = value;
    }
}
